// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"daa88b71a5e52a94a032","655":"7dba7f12c58b425161a0"}[chunkId] + ".js";
};